import httpClient from "@/common/service/HttpClient";
import { endPoints } from "@/constants/apiSetting";
const RosterService = {
  getRoster(obj) {
    return httpClient.post(endPoints.getRoster, obj);
  },
  genRoster(obj) {
    return httpClient.post(endPoints.genRoster, obj);
  },
  deleteRoster(obj) {
    return httpClient.post(endPoints.deleteRoster, obj);
  },
  updateRoster(obj) {
    return httpClient.post(endPoints.updateRoster, obj);
  },
  addRoster(obj) {
    return httpClient.post(endPoints.addRoster, obj);
  },
  import(obj) {
    return httpClient.post(endPoints.ImportRoster, obj);
  }
};

export default RosterService;



// WEBPACK FOOTER //
// ./src/service/RosterService.js